import type { trpc } from './trpc';

type Utils = ReturnType<typeof trpc.useUtils>;

/**
 * Anything that changes a transaction (category, transfer, exclusion, import,
 * reconcile) affects every money view. Refresh them together so the overview,
 * inbox, insights and lists never disagree.
 */
export function invalidateFinancials(utils: Utils) {
  return Promise.all([
    utils.period.invalidate(),
    utils.budget.invalidate(),
    utils.insights.invalidate(),
    utils.transaction.invalidate(),
    utils.sync.flagged.invalidate(),
    utils.sync.flaggedCount.invalidate(),
    utils.recurringBill.invalidate(),
    utils.loan.invalidate(),
    utils.income.invalidate(),
    utils.savings.invalidate(),
  ]);
}
